import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioIndicator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Radiobox",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 20.5,
			height: 20.5,
			rx: 10.25,
			stroke: "#E7392D",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("circle", {
			id: "selected",
			cx: 11,
			cy: 11,
			r: 8,
			fill: "#E7392D"
		})]
	})
});
export default SvgRadioIndicator;
